"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.string.starts-with");

var _ravenJs = _interopRequireDefault(require("raven-js"));

var _config = require("../utils/config");

var _constants = require("../constants");

var _this = void 0;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  var _getConfig = (0, _config.getConfig)(),
      httpThreshold = _getConfig.httpThreshold;

  var http = {
    data: {},
    add: function add(url) {
      if (!url.startsWith(_constants.SERVER_URL)) {
        this.data[url] = Date.now();
      }
    },
    del: function del(url) {
      var startTime = this.data[url];

      if (startTime) {
        var duration = Date.now() - startTime;

        if (duration > httpThreshold) {
          _ravenJs.default.captureException(new Error("Http Timeout captured: ".concat(url, " ").concat(duration, "ms")));
        }

        delete this.data[url];
      }
    }
  };
  var xhrproto = window.XMLHttpRequest && window.XMLHttpRequest.prototype;
  var origOpen = xhrproto.open;

  xhrproto.open = function (method, url) {
    http.add(url);
    return origOpen.call(xhrproto, method, url);
  };

  var origFetch = window.fetch;

  window.fetch = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    http.add(args[0]);
    return origFetch.apply(_this, args);
  };

  var HTTP_TYPE = 'http';
  var origCapture = _ravenJs.default.captureBreadcrumb;

  _ravenJs.default.captureBreadcrumb = function (args) {
    var type = args.type,
        data = args.data;

    if (type === HTTP_TYPE) {
      http.del(data.url);
    }

    return origCapture.call(_ravenJs.default, args);
  };
};

exports.default = _default;